import React, { ComponentProps, Fragment, ReactNode } from 'react';

import { Screen } from '@zapier/theme';
import { useMediaProps } from '@zapier/responsive-utils';
import { Margin, Text } from '@zapier/design-system';

import ExtendedIcon from 'app/developer-v3/components/ExtendedIcon';
import Link from 'app/common/components/Link';

import CTA from '../CTA';
import LockIcon from './LockIcon';
import Ordinal from '../Ordinal';

type Props = {
  action: ReactNode;
  description: string;
  hint: ReactNode;
  icon: ComponentProps<typeof ExtendedIcon>['name'];
  isActive: boolean;
  isLocked: boolean;
  learnMoreUrl?: string;
  ordinal: number;
  title: string;
};

const defaultProps = {
  hint: {},
  isLocked: false,
  onButtonClick: () => {},
};

function Lockable({
  action,
  description,
  hint,
  icon,
  isActive,
  isLocked,
  learnMoreUrl,
  ordinal,
  title,
}: Props) {
  const { size = 'small' } = useMediaProps({
    [Screen.queries.tabletLandscapePlus]: { size: 'large' },
  });

  return (
    <CTA>
      <Ordinal isActive={isActive} number={ordinal} />
      <CTA.Info icon={icon} title={title}>
        <Margin margin="10px 0px 0px">
          <Text>{description}</Text>{' '}
          {learnMoreUrl && (
            <Fragment>
              {' '}
              <Link href={learnMoreUrl}>Learn more</Link>.
            </Fragment>
          )}
        </Margin>
      </CTA.Info>
      <CTA.Action align={isLocked ? 'center' : 'start'} size={size}>
        {isLocked ? <LockIcon hint={hint} /> : action}
      </CTA.Action>
    </CTA>
  );
}

Lockable.defaultProps = defaultProps;

export default Lockable;
